import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-121754e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "取消", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "disabledClass" }, "取消", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "确认取消", -1))
const _hoisted_12 = { key: 5 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "驳回取消", -1))
const _hoisted_14 = {
  key: 6,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_logist_detail = _resolveComponent("logist-detail")!
  const _component_noodle_print = _resolveComponent("noodle-print")!
  const _component_RemarksData = _resolveComponent("RemarksData")!
  const _component_BaseMsg = _resolveComponent("BaseMsg")!
  const _component_BatchImport = _resolveComponent("BatchImport")!
  const _component_CancelOrder = _resolveComponent("CancelOrder")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { style: {"width":"100%"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({ label: "CLUAN单号" }, _ctx.validateInfos.gwtNo, {
                      labelCol: {span: 9},
                      wrapperCol: {span: 15}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          style: {"height":"30px"},
                          value: _ctx.modelRef.gwtNo,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.gwtNo) = $event)),
                          placeholder: "批量查询请使用空格或换行或英文逗号隔开"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({ label: "目的国派送单号" }, _ctx.validateInfos.deliveryNo, {
                      labelCol: {span: 9},
                      wrapperCol: {span: 15}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          style: {"height":"30px"},
                          value: _ctx.modelRef.deliveryNo,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.deliveryNo) = $event)),
                          placeholder: "批量查询请使用空格或换行或英文逗号隔开"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({ label: "交易单号:" }, _ctx.validateInfos.transactionNo, {
                      labelCol: {span: 9},
                      wrapperCol: {span: 15}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          style: {"height":"30px"},
                          value: _ctx.modelRef.transactionNo,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.transactionNo) = $event)),
                          placeholder: "批量查询请使用空格或换行或英文逗号隔开"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({ label: "　　　　目的国" }, _ctx.validateInfos.destination, {
                      labelCol: {span: 9},
                      wrapperCol: {span: 15}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          allowClear: "",
                          "show-search": "",
                          getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                          "filter-option": _ctx.filterOption,
                          value: _ctx.modelRef.destination,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.destination) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countrylistSet, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: item.name,
                                value: item.code
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["getPopupContainer", "filter-option", "value"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({ label: "订单状态" }, _ctx.validateInfos.status, {
                      labelCol: {span: 9},
                      wrapperCol: {span: 15}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          allowClear: "",
                          getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                          value: _ctx.modelRef.eventCodeDisplay,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.eventCodeDisplay) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventCodeList, (item) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: item,
                                value: item.code
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.displayDescCn), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["getPopupContainer", "value"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, _mergeProps({ label: "　创建日期" }, _ctx.validateInfos.sttime, {
                      labelCol: {span: 9},
                      wrapperCol: {span: 20}
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_range_picker, {
                          getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                          "value-format": "YYYY-MM-DD",
                          value: _ctx.modelRef.sttime,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelRef.sttime) = $event))
                        }, null, 8, ["getPopupContainer", "value"])
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, {
              gutter: 24,
              style: {"position":"relative","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleShow(_ctx.e,'batchimport')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("导入物流单")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.createdLogistics
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("创建物流单")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleShow(_ctx.e,'batchPrinting'))),
                      loading: _ctx.loadingBtn
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("打印面单")
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_a_button, {
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleShow(_ctx.e,'batchCancel')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("取消物流单")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      disabled: _ctx.$store.state.loading.loading,
                      onClick: _ctx.handleDownload
                    }, {
                      default: _withCtx(() => [
                        (_ctx.$store.state.loading.loading)
                          ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                          : _createCommentVNode("", true),
                        _createTextVNode("导出")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.handleSearch,
                      style: {"position":"absolute","right":"85px","top":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_a_button, {
                      onClick: _ctx.handleRest,
                      style: {"position":"absolute","right":"12px","top":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"margin-top":"10px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              style: {"width":"100%"},
              rowKey: "id",
              columns: _ctx.columns,
              dataSource: _ctx.list,
              "row-selection": _ctx.rowSelection,
              pagination: _ctx.pagination,
              loading: _ctx.loading,
              size: "small",
              scroll: {x:'calc(100%-100vw)'},
              onChange: _ctx.handleTableChange
            }, {
              bodyCell: _withCtx(({column,text,record}) => [
                (column.dataIndex === 'orderSource')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'orderSource')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'productType')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'productType')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'gwtNo')
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 2,
                      placement: "top"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(record.gwtNo), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.handleShow(record,'gwt'))
                        }, _toDisplayString(text), 9, _hoisted_2)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'createdAt')
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 3,
                      placement: "top"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(record.createdAt), 1)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(record.createdAt), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'eventCodeCn')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      (record.eventCodeCn === null && record.firstImgFileId === null)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" 下单失败 ")
                          ], 64))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            onClick: ($event: any) => (_ctx.handleShow(record,'eventCodeCn'))
                          }, _toDisplayString(record.eventCodeCn != null? record.eventCodeCn: (record.firstImgFileId == null ? '下单失败': '暂无物流节点')), 9, _hoisted_3))
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'createdAt')
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 5,
                      placement: "top"
                    }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(record.createdAt), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'ascanTime')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createTextVNode(_toDisplayString(_ctx.changeTxt(text, 'ascanTime')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'hasBattery')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _createTextVNode(_toDisplayString(record.hasBattery === 1 ? '带电' : '普货'), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                      (column.dataIndex === 'action')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("a", {
                              onClick: ($event: any) => (_ctx.handleShow(record, 'label'))
                            }, "面单打印", 8, _hoisted_4),
                            _createVNode(_component_a_divider, { type: "vertical" }),
                            (!record.cancel)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                  _createVNode(_component_a_popconfirm, {
                                    title: "确认取消订单?",
                                    onConfirm: ($event: any) => (_ctx.handleOrderCtrl(record, '申请取消订单'))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9)),
                            (record.eventCode == 'CALORD-ORD')
                              ? (_openBlock(), _createBlock(_component_a_divider, {
                                  key: 2,
                                  type: "vertical"
                                }))
                              : _createCommentVNode("", true),
                            (record.eventCode == 'CALORD-ORD')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                  _createVNode(_component_a_popconfirm, {
                                    title: "确认取消订单?",
                                    onConfirm: ($event: any) => (_ctx.handleOrderCtrl(record, '确认取消'))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]))
                              : _createCommentVNode("", true),
                            (record.eventCode == 'CALORD-ORD')
                              ? (_openBlock(), _createBlock(_component_a_divider, {
                                  key: 4,
                                  type: "vertical"
                                }))
                              : _createCommentVNode("", true),
                            (record.eventCode == 'CALORD-ORD')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                  _createVNode(_component_a_popconfirm, {
                                    title: "驳回取消订单?",
                                    onConfirm: ($event: any) => (_ctx.handleOrderCtrl(record,'驳回取消'))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_13
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "dataSource", "row-selection", "pagination", "loading", "scroll", "onChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: _ctx.title,
      width: _ctx.typeStr=='remarks' || _ctx.typeStr=='eventCodeCn' || _ctx.typeStr == 'batchimport' || _ctx.typeStr == 'batchCancel' ? '60%' : _ctx.typeStr=='msg'?'30%':'100%',
      "wrap-class-name": _ctx.typeStr=='remarks' || _ctx.typeStr=='eventCodeCn' || _ctx.typeStr=='msg' || _ctx.typeStr == 'batchimport' || _ctx.typeStr == 'batchCancel'  ? null : 'full-modal',
      visible: _ctx.visible,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.visible) = $event)),
      footer: null,
      maskStyle: _ctx.typeStr=='remarks' || _ctx.typeStr=='eventCodeCn' || _ctx.typeStr=='msg' || _ctx.typeStr == 'batchimport' || _ctx.typeStr == 'batchCancel'  ? {} : {backgroundColor: '#fff'}
    }, {
      default: _withCtx(() => [
        (_ctx.visible&&_ctx.typeStr=='gwt')
          ? (_openBlock(), _createBlock(_component_logist_detail, {
              key: 0,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visible) = $event)),
              tableData: _ctx.tableData,
              countrylist: _ctx.countrylist
            }, null, 8, ["visible", "tableData", "countrylist"]))
          : _createCommentVNode("", true),
        (_ctx.visible&&(_ctx.typeStr=='label' || _ctx.typeStr=='batchPrinting'))
          ? (_openBlock(), _createBlock(_component_noodle_print, {
              key: 1,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visible) = $event)),
              imgUrl: _ctx.imgUrl
            }, null, 8, ["visible", "imgUrl"]))
          : _createCommentVNode("", true),
        (_ctx.visible&&_ctx.typeStr=='remarks')
          ? (_openBlock(), _createBlock(_component_RemarksData, {
              key: 2,
              defaultRemarks: _ctx.defaultRemarks,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.visible) = $event)),
              onChildRemarks: _ctx.getChildRemarks
            }, null, 8, ["defaultRemarks", "visible", "onChildRemarks"]))
          : _createCommentVNode("", true),
        (_ctx.visible&&_ctx.typeStr=='eventCodeCn')
          ? (_openBlock(), _createBlock(_component_BaseMsg, {
              key: 3,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.visible) = $event)),
              typeStr: _ctx.typeStr,
              logisticsData: _ctx.logisticsData
            }, null, 8, ["visible", "typeStr", "logisticsData"]))
          : _createCommentVNode("", true),
        (_ctx.visible&&_ctx.typeStr=='batchimport')
          ? (_openBlock(), _createBlock(_component_BatchImport, {
              key: 4,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.visible) = $event)),
              typeStr: _ctx.typeStr
            }, null, 8, ["visible", "typeStr"]))
          : _createCommentVNode("", true),
        (_ctx.visible&&_ctx.typeStr=='batchCancel')
          ? (_openBlock(), _createBlock(_component_CancelOrder, {
              key: 5,
              visible: _ctx.visible,
              "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.visible) = $event)),
              typeStr: _ctx.typeStr,
              orderList: _ctx.orderList.value,
              onCommit: _ctx.statusCommit
            }, null, 8, ["visible", "typeStr", "orderList", "onCommit"]))
          : _createCommentVNode("", true),
        (_ctx.visible&&_ctx.typeStr=='msg')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.isNum=='100')
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _createTextVNode("您尚未进行账号认证，请认证后再签署！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleGotoCheck('check')))
                    }, "账号认证"),
                    _createTextVNode("”进行认证。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='101')
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                    _createTextVNode("您尚未进行合同签署，请签署后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleGotoCheck('check')))
                    }, "合同签署"),
                    _createTextVNode("”进行签署。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='102')
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                    _createTextVNode("您的账户余额不足，无法下单，请点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleGotoCheck('rech')))
                    }, "充值"),
                    _createTextVNode("”。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='103')
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                    _createTextVNode("您的账户存在逾期的账单，账户已冻结，请还款后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleGotoCheck('rech')))
                    }, "充值"),
                    _createTextVNode("”进行还款。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='104')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createTextVNode("您的账户已冻结，请充值后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleGotoCheck('rech')))
                    }, "充值"),
                    _createTextVNode("”进行充值。")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNum=='105')
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _createTextVNode("您的账户余额不足，请充值后再下单！点击“"),
                    _createElementVNode("a", {
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleGotoCheck('rech')))
                    }, "充值"),
                    _createTextVNode("”进行充值。")
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "width", "wrap-class-name", "visible", "maskStyle"])
  ]))
}